import { SvgIcon } from '@mui/material';
import { FC } from 'react';

import { IconProps } from '../types';

export const GooglePayIcon: FC<IconProps> = ({ width = 32, height = 32 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={[0, 0, width, height].join(' ')}
      fill="none"
      stroke="none"
      strokeWidth="0"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2177_148930)">
        <path
          d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
          fill="white"
        />
        <path
          d="M15.2805 16.299V18.8785H14.4622V12.5082H16.6325C16.8916 12.5028 17.1492 12.5488 17.3904 12.6434C17.6316 12.7381 17.8516 12.8796 18.0379 13.0597C18.226 13.229 18.3758 13.4365 18.477 13.6684C18.5783 13.9002 18.6287 14.1511 18.625 14.4041C18.6304 14.6585 18.5807 14.911 18.4793 15.1444C18.378 15.3777 18.2274 15.5864 18.0379 15.7562C17.6584 16.118 17.1899 16.2988 16.6325 16.2985H15.2805V16.299ZM15.2805 13.2925V15.5162H16.6528C16.8033 15.5207 16.953 15.4937 17.0924 15.437C17.2318 15.3803 17.3579 15.2951 17.4625 15.1869C17.5666 15.0857 17.6493 14.9647 17.7058 14.831C17.7623 14.6973 17.7914 14.5536 17.7914 14.4084C17.7914 14.2633 17.7623 14.1196 17.7058 13.9859C17.6493 13.8522 17.5666 13.7312 17.4625 13.63C17.3592 13.5195 17.2336 13.4322 17.094 13.374C16.9544 13.3157 16.804 13.2878 16.6528 13.292H15.2805V13.2925Z"
          fill="#5F6368"
        />
        <path
          d="M20.5106 14.3789C21.1155 14.3789 21.593 14.5405 21.943 14.8638C22.293 15.1871 22.4679 15.6303 22.4675 16.1935V18.8797H21.6848V18.2749H21.6492C21.3104 18.773 20.8597 19.022 20.2972 19.022C19.817 19.022 19.4153 18.8797 19.092 18.5951C18.9369 18.4644 18.8129 18.3008 18.729 18.1162C18.6451 17.9315 18.6035 17.7305 18.6072 17.5277C18.6072 17.0767 18.7776 16.718 19.1185 16.4517C19.4594 16.1853 19.9144 16.0518 20.4837 16.0511C20.9696 16.0511 21.3698 16.1401 21.6843 16.318V16.1309C21.6852 15.9927 21.6554 15.856 21.5969 15.7307C21.5384 15.6054 21.4528 15.4947 21.3463 15.4067C21.1299 15.2114 20.8478 15.1049 20.5564 15.1083C20.0993 15.1083 19.7376 15.3011 19.4712 15.6867L18.7505 15.2328C19.147 14.6635 19.7337 14.3789 20.5106 14.3789ZM19.4519 17.5455C19.4514 17.6496 19.4757 17.7524 19.5229 17.8452C19.5701 17.9381 19.6388 18.0183 19.7233 18.0792C19.9043 18.2215 20.129 18.2969 20.3592 18.2927C20.7045 18.2921 21.0355 18.1546 21.2797 17.9104C21.5508 17.6553 21.6863 17.3559 21.6863 17.0123C21.4312 16.809 21.0754 16.7073 20.6189 16.7073C20.2865 16.7073 20.0093 16.7875 19.7874 16.9477C19.5632 17.1104 19.4519 17.3081 19.4519 17.5455Z"
          fill="#5F6368"
        />
        <path
          d="M26.9607 14.5195L24.2282 20.7993H23.3835L24.3975 18.602L22.6007 14.5195H23.4902L24.7888 17.6505H24.8066L26.0697 14.5195H26.9607Z"
          fill="#5F6368"
        />
        <path
          d="M11.9736 15.7441C11.9739 15.4947 11.9528 15.2458 11.9106 15H8.45935V16.4094H10.4361C10.3956 16.6346 10.31 16.8491 10.1844 17.0403C10.0588 17.2314 9.89575 17.3951 9.70515 17.5216V18.4364H10.8849C11.5756 17.7996 11.9736 16.8577 11.9736 15.7441Z"
          fill="#4285F4"
        />
        <path
          d="M8.45946 19.3186C9.44702 19.3186 10.2786 18.9943 10.8849 18.4352L9.70526 17.5203C9.3769 17.7429 8.95402 17.87 8.45946 17.87C7.5049 17.87 6.6947 17.2265 6.40498 16.3594H5.1897V17.3023C5.4943 17.9083 5.96138 18.4179 6.53874 18.7739C7.11614 19.13 7.7811 19.3185 8.45946 19.3186Z"
          fill="#34A853"
        />
        <path
          d="M6.40501 16.3593C6.25185 15.9049 6.25185 15.4128 6.40501 14.9585V14.0156H5.18973C4.93349 14.5255 4.80005 15.0882 4.80005 15.6589C4.80005 16.2295 4.93349 16.7923 5.18973 17.3021L6.40501 16.3593Z"
          fill="#FBBC04"
        />
        <path
          d="M8.45946 13.4488C8.98134 13.4403 9.48562 13.6375 9.8633 13.9978L10.9078 12.9532C10.2455 12.3312 9.36806 11.9896 8.45946 12.0002C7.7811 12.0003 7.11614 12.1888 6.53874 12.5449C5.96138 12.901 5.4943 13.4105 5.1897 14.0166L6.40498 14.9594C6.6947 14.0923 7.5049 13.4488 8.45946 13.4488Z"
          fill="#EA4335"
        />
      </g>
      <defs>
        <clipPath id="clip0_2177_148930">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
